import React, { Component, ReactElement, constructor, useEffect, useState } from 'react'
import './AsnUploadForm.scss'
import CoAUploader from '../services/CoAUpload'
import ToolTipView from '../toolTipView/ToolTipView'
import CoAModalContext from './context'
import GenericModal from '../modal/Modal'
import CoAModal from './CoAModal'
import Saving from '../loading/Saving'
import { toHtml } from '@fortawesome/fontawesome-svg-core'
import { render } from 'react-dom'
interface Props {
    // asn: any //TODO: properly define asn
    // uploadFunction: any
    lp: string
    harvestDate: string
    lotCode: string
    sku: any
    packagingDate:string,
    header:any,
    asn:any
    disabled:boolean
    saveAsn(): Promise<any>
    history: any
    coAUploadCallBack: (isCoAUplaoded: boolean, intialLoad: boolean) => Promise<any> //if the coA is empyt we have a callback to update the parent component
    preOpen: () => boolean
    qlCat?: string
    qlCoa?: string
}

export const CoAUploadButton = (props: Props): ReactElement<Props> => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploading] = useState(false);
  const [uploadName, setUploadName] = useState('');
  const [buttonStyle, setButtonStyle] = useState('file btn btn-secondary');

  useEffect(() => {
    setUploadName(props.qlCoa !== undefined ? props.qlCoa.trim() : '');
  }, [props.asn.qvCoa, props.qlCoa]);

  useEffect(() => {
    const defaultStyle = "file btn btn-secondary";

    setButtonStyle(`${defaultStyle} ${(props.qlCoa != undefined && props.qlCoa.trim() != '') ? 'green' : 'red'}`);
  }, [props.qlCoa, props.asn.qvCoa]);
  
  const create_UUID = () => {
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c=='x' ? r :(r&0x3|0x8)).toString(16);
    });
    return uuid;
  }

  const openModal = () => {
      if (!props.preOpen()) {
        return;
      }

      setIsModalOpen(true);
    }

  const closeModal = () => {
    setIsModalOpen(false);
  }

  const inputId = "coaUpload" + props.sku + create_UUID();

  return(
    <div style={{"border":"none!important", "outline":"none!important", "boxShadow": "none!important"}}>

      {uploading === true
        ? <Saving />
        : (props.qlCat?.trim() !== "" || props.qlCoa?.trim() !== "")
          ? <CoAModalContext.Provider
            value={{
              isOpen: isModalOpen,
              open: openModal,
              close: closeModal,
              lotCode: props.lotCode,

            }}
          >
            <CoAModalContext.Consumer>
              {({ open }) => {
                const openAction = () => {
                  open();
                }

                const inputId = "modalDeploy" + props.sku + props.asn.lineID + create_UUID();;

                return (
                  <ToolTipView placement="top" title={`Uploaded: ${uploadName}`}>
                    <div style={{ textAlign: "center" }}>
                      <input onClick={openAction} style={{ "display": "none" }} id={inputId} accept="application/pdf" />
                      <label className="hiddenInput" htmlFor={inputId}>
                        <div className={buttonStyle}>
                          CoA
                        </div>
                      </label>
                    </div>
                  </ToolTipView>
                )
              }}
            </CoAModalContext.Consumer>
            <CoAModalContext.Consumer>
              {({ isOpen }) => {
                return (
                  <GenericModal isOpen={isOpen}>
                    {(
                      <CoAModal
                        close={closeModal}
                        coAFileName={`${uploadName}`}
                        asnStatus={props.asn.lineStatus}
                        header={props.header}
                        asn={props.asn}
                        lp={props.lp}
                        harvestDate={props.harvestDate}
                        lotCode={props.lotCode}
                        sku={props.sku}
                        packagingDate={props.packagingDate}
                        key={`${uploadName}`}
                      />
                    )}
                  </GenericModal>
                )
              }}
            </CoAModalContext.Consumer>
          </CoAModalContext.Provider>
          : <ToolTipView placement="top" title="Upload COA files directly to the Lot">
        <div style={{ textAlign: "center" }}>
          <label className="hiddenInput" htmlFor={inputId}>
            <div className={buttonStyle}>
              CoA
            </div>
          </label>
        </div>
      </ToolTipView>

      }
    </div>
  )
}

export default CoAUploadButton;
